import React from "react";
import { useNavigate } from "react-router-dom";



export default function CivilWorkCard({ count, title, navLink, cardName, imgPath, CivilWorkCardNavigate }) {
    const navigate = useNavigate()

    // const handleGardenDailyWorkCard = () => {
    //     navigate(navLink)
    // }
    return (
        // <div style={{ cursor:'pointer' }} className="mb-1 p-3 shadow blue_borders bg-white mb-md-2 daily-card-width" onClick={() => CivilWorkCardNavigate(title)}>
        //     <div className="d-flex flex-column justify-content-between" style={{ height: '100%' }}>
        //         <div className="text-center" >
        //             <div className="d-flex justify-content-between align-items-center pb-3">
        //                 <h4>{count}</h4>
        //                 <img className={cardName} style={{ height: '50px', width: '35px' }} src={imgPath} alt="" />
        //             </div>

        //         </div>
        //         <div>
        //             <h6 className="text-black"><b>{title}</b></h6>
        //         </div>
        //     </div>
        // </div>

        <div style={{ cursor: 'pointer', height: '100px' }} className=" mb-3 px-3 pt-2 shadow blue_borders bg-white  daily-card-width" onClick={() => CivilWorkCardNavigate(title)}>
            <div className="row d-flex align-items-center pt-3 justify-content-center" >

                <div className="col-lg-8 ">
                    <h4>{count}</h4>
                    <h6 className="text-black"><b>{title}</b></h6>
                </div>

                <div className="col-lg-4 d-flex  align-items-center justify-content-center" >
                    <img className={cardName} style={{ height: '60px' }} src={imgPath} alt="" />
                </div>

            </div>
        </div>
    )
}